import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_input = _resolveComponent("localized-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_localized_input, {
      labelKey: "Nome",
      labelValue: "Nome",
      placeholderKey: "Nome",
      placeholderValue: "Nome",
      modelValue: _ctx.item.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.name) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_localized_input, {
      labelKey: "Cognome",
      labelValue: "Cognome",
      placeholderKey: "Cognome",
      placeholderValue: "Cognome",
      modelValue: _ctx.item.surname,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.surname) = $event))
    }, null, 8, ["modelValue"])
  ]))
}